import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import LabourCessList from '../../../components/Reconciliation/LabourCess/LabourCessList';
import Spinner from '../../../components/Tools/spinner';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';

const LabourCess = () => {
    const navigate = useNavigate();
    const { financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [selectedTDS, setSelectednvoice] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setToSearchStr] = useState('');
    const [dateColumn, setDateColumn] = useState('voucher_date');
    const [loading, setLoading] = useState(false);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    };

    const handleAddChallan = () => {
        if (!selectedTDS.length) {
            toast.error('Please select at least one invoice', {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        navigate('/add-labour', { state: { data: selectedTDS } });
    };

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
            <div className="row" style={{ padding: '10px 16px' }}>
                <div className="col-md-6">
                    <h4 style={{ color: '#28326f', margin: 0 }}>Labour Cess</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Labour Cess" />
                </div>
                <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: 'auto', float: 'right' }}>
                        <button
                            type="button"
                            className="submit_button"
                            onClick={handleAddChallan}
                        >
                            Add Challan
                        </button>
                    </div>
                </div>
            </div>
            <div className="scheme p-3">
                <LabourCessList
                    selectedInvoice={selectedTDS}
                    setSelectednvoice={setSelectednvoice}
                    dateColumn={dateColumn}
                    fromDate={fromDate}
                    toDate={toDate}
                    searchStr={searchStr}
                    loading={loading}
                    setLoading={setLoading}
                />
            </div>
        </div>
    );
};

export default LabourCess;
